export default __webpack_public_path__ + "static/media/about-us.8ce15076.svg";